import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { Modal } from './ui/Modal';

interface InstapaperPremiumModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Modal heading; defaults to "Premium Feature". */
  title?: string;
  /** Body copy; defaults to the full-text-search message. */
  message?: string;
}

function InstapaperPremiumModal({
  isOpen,
  onClose,
  title,
  message,
}: InstapaperPremiumModalProps) {
  const heading = title ?? t`Premium Feature`;
  const body = message ?? t`Full-text search is available with Instapaper Premium.`;
  return (
    <Modal.Root isOpen={isOpen} onClose={onClose} className="p-6" ariaLabel={heading}>
      <Modal.Header title={heading} />
      <Modal.Body>
        <p className="text-gray-600">{body}</p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Actions>
          <button onClick={onClose} className="button-secondary">
            <Trans>Cancel</Trans>
          </button>
          <a href="/premium" className="button-primary">
            <Trans>Learn More</Trans>
          </a>
        </Modal.Actions>
      </Modal.Footer>
    </Modal.Root>
  );
}

export default InstapaperPremiumModal;
